import * as type from './referralActionTypes';

export const fetchMyReferrals = () => ({
  type: type.FETCH_MY_REFERRALS,
});

export const setReferrals = (referrals) => ({
  type: type.SET_REFERRALS,
  referrals,
});

export const setReferralsLoading = (loading) => ({
  type: type.SET_REFERRALS_LOADING,
  loading,
});

export const setReferralsError = (error) => ({
  type: type.SET_REFERRALS_ERROR,
  error,
});

export const sendReferral = (emailTo) => ({
  type: type.SEND_REFERRAL,
  emailTo,
});

export const setSendingInvitation = (sending) => ({
  type: type.SET_SENDING_INVITATION,
  sending,
});

export const setInvitationMessage = (message) => ({
  type: type.SET_INVITATION_MESSAGE,
  message,
});

export const clearInvitationMessage = () => ({
  type: type.CLEAR_INVITATION_MESSAGE,
});
